<template>
  <div class="real-auth-result">
    <img v-if="result === 'true'" :src="$setPicSize(successImg)" :class="[isHeroClub ? 'heroClubImg' : '']"/>
    <img v-if="result === 'false'" :src="$setPicSize(failImg)" />
    <div class="result-info">
      <header v-if="result === 'true'">恭喜您认证成功</header>
      <header v-if="result === 'false'">很遗憾认证失败</header>
      <div class="desc">{{ resInfo }}</div>
    </div>
    <div class="operation-area">
      <z-button v-for="ctx in buttonCtxes" :key="ctx.type" @click="doCommand(ctx)" :text="ctx.text" :type="btnType(ctx.style)" :style="isHeroClub && ctx.style == 'highlight' ? heroClubButtonStyle : {}"/>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { Button } from '@zz-common/zz-ui'
// import { lego } from '@zz-common/lego'
import { getbizlicenseresult } from '@api/resourceApi'
import { toast } from '../../../native'
import { queryParams, isHeroClubByUa } from '@lib/utils'

const query = queryParams()
// const zzv = query.zzv || getCookie('v')
// const vers = zzv && zzv.split('.')
// let lower54 = false
// if (vers && ((vers[0] === 5 && vers[1] < 4) || vers[0] < 5) && !isCheckApp && !isHunterApp) {
//   lower54 = true
// }

export default {
  name: 'ResultComp',
  data() {
    return {
      sourceCode: query.sourceCode || this.$route.query.sourceCode,
      // from: query.from || this.$route.query.from,
      // code: query.code || this.$route.query.code,
      // agreementNo: query.agreementNo || this.$route.query.agreementNo,
      authtype: query.authtype || this.$route.query.authtype || '', //  认证类型challenge代表二次挑战认证
      result: isHeroClubByUa(), //除了侠客汇页其他页面默认都是false,
      resInfo: '',
      buttonCtxes: [],
      // isCheckApp: isCheckApp,
      // isHunterApp: isHunterApp,
      failImg: '2980c180-8a0e-48e5-9ffb-ec7ad3ec4766.png',
      isHeroClub: isHeroClubByUa(),
      heroClubButtonStyle: {
        background: '#111111',
        color: '#F2D3A9',
        border: '1px solid #111111'
      }
    }
  },
  computed: {
    successImg() {
      return this.isHeroClub ? '629bc05a-e027-42ae-868c-0ecab5e37727.png' : 'f9436be4-ddfb-4f7b-8047-f0ae914e714c.png'
    },
    btnType() {
      return (style) => {
        return style === 'highlight' ? 'primary' : 'default'
      }
    }
  },
  components: {
    zButton: Button
  },
  methods: {
    // adapterOS() {
    //   if (isHunterApp) {
    //     this.successImg = 'n_v22b700e1a672d4efcb1b00ce4207c11c9.png'
    //     this.failImg = 'n_v23e94a6f9c8f34a5e98c65a7e12f7ffe2.png'
    //   }
    // },
    $setPicSize(url) {
      return setPicSize(url, 500, 500)
    },
    adapterButtonCtxes(data) {
      const buttonData = data.map((b) => {
        return {
          cmd: b.type,
          targetUrl: b.mUrl,
          text: b.buttonDesc,
          style: b.style || 'normal'
        }
      })
      // if (isCheckApp) {
      //   buttonData = buttonData.reverse().map((b) => {
      //     if (b.text.indexOf('退出') > -1) {
      //       b.text = '退出'
      //     }
      //     return b
      //   })
      // }
      this.buttonCtxes = buttonData
    },
    doCommand(ctx) {
      // lego.send({
      //   pagetype: 'ZZUP_BUSREALAUTH_RESULT',
      //   actiontype: 'CLICK',
      //   backup: {
      //     sourceCode: this.from,
      //     type: ctx.cmd
      //   }
      // })
      if (ctx.cmd === 'close') {
        native.close()
      } else if (ctx.cmd === 'jump') {
        native.skipToUrl({
          targetUrl: ctx.targetUrl,
          needClose: '1'
        })
      }
      // else if (ctx.cmd === 'reverify') {
      // getuserauthcardinfo({
      //   agreementno: this.agreementNo
      // })
      //   .then((res) => {
      //     localStorage.setItem('userCardNo', res.userCardNo)
      //     localStorage.setItem('userName', res.userName)
      //   })
      //   .catch((err) => {
      //     console.error(err)
      //     toast({
      //       msg: err.message || '获取用户实名失败',
      //       style: '2'
      //     })
      //   })
      //   native.skipToUrl({
      //     targetUrl: `https://feentry.zhuanzhuan.com/spam?clientid=qualityauth&sourceCode=${this.sourceCode}&authtype=reverify`,
      //     newPageTitle: '资质认证',
      //     needClose: '1'
      //   })
      // }
      // else if (ctx.cmd === 'audit') {
      //   console.log('cmd', ctx.cmd)
      //   native.skipToUrl({
      //     targetUrl: `https://app.zhuanzhuan.com/zz/redirect/faceauthcheckredirect?sourceCode=${this.from}`,
      //     needClose: '1'
      //   })
      // }
    }
  },
  created() {
    native.setTitle({
      title: '资质认证'
    })
    console.log('code', this.code)
    getbizlicenseresult({
      sourcecode: this.sourceCode
    })
      .then((res) => {
        console.info(res)
        // lego.send({
        //   pagetype: 'ZZUP_BUSREALAUTH_RESULT',
        //   actiontype: 'PAGE_SHOW',
        //   backup: {
        //     sourceCode: this.from,
        //     result: res.isPass
        //   }
        // })
        this.result = res.isPass
        this.resInfo = res.text
        this.adapterButtonCtxes(res.retButtons)
        // if (this.result === 'true') {
        //   // localStorage.removeItem('user_name')
        //   // localStorage.removeItem('card_id')

        //   native.wrap('sendNotification')({
        //     name: 'ZZ_NOTIFICATION_REAL_CERTIFICATION_SUCCESS',
        //     args: JSON.stringify({ userId: getCookie('uid') })
        //   })
        // }
      })
      .catch((err) => {
        console.error(err)
        toast({
          msg: err.errMsg || '提交失败',
          style: '2'
        })
      })
    // this.adapterOS()
  }
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     const pageLock = query.lock || vm.$route.query.lock
  //     if (!pageLock && lower54 && !isHunterApp) {
  //       native.skipToUrl({
  //         targetUrl: location.href.replace(/\?(.*)/, '?lock=1&$1'),
  //         needClose: '1'
  //       })
  //     }
  //   })
  // }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
